import { useState } from "react"
import { Button, Col, Container, Row, Stack } from "react-bootstrap"
import { useParams } from "react-router"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import { useDeleteScrapeEntryMutation, useGetScrapeEntryByIdQuery } from "../../../services/bClientApi"
import ScrapeEntryEntry from "../../../Components/ScrapeEntry/ScrapeEntryEntry/ScrapeEntryEntry"

export default function DeleteScrapeEntryPage() {

    const [
        deleteScrapeEntry,
        {
            isLoading: deleteLoading,
            error: deleteError
        }
    ] = useDeleteScrapeEntryMutation()

    const { scrapeEntryId = '' } = useParams()
    const dispatch = useAppDispatch()

    const [deleteClicked, setDeleteClicked] = useState(false)

    const {
        data,
        error,
        isLoading
    } = useGetScrapeEntryByIdQuery(scrapeEntryId, { skip: !scrapeEntryId || deleteClicked })
    const scrapeEntryData = data || {}

    const scrapeEntryDeleteFn = async () => {
        if (scrapeEntryId) {
            const deleteValue = await deleteScrapeEntry(scrapeEntryId).unwrap()
            if (deleteValue) {
                dispatch(navigateTo('/scrape-entries/'))
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Scrape Entry</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {scrapeEntryId && scrapeEntryData && !isLoading && (
                        <div className="scrape-entry-info">
                            <div className="mb-4">
                                <h4>Scrape Entry to Delete</h4>
                                <ScrapeEntryEntry
                                    scrapeEntryData={scrapeEntryData}
                                    fullView={true}
                                    showActions={false}
                                />
                            </div>

                            <Stack gap={3}>
                                <div className="alert alert-warning">
                                    <strong>Warning!</strong> Are you sure you want to delete this scrape entry? This action cannot be undone.
                                </div>
                                <div>
                                    <Button 
                                        variant="secondary" 
                                        className="me-2"
                                        onClick={() => dispatch(navigateTo(`/scrape-entries/${scrapeEntryId}`))}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="warning" 
                                        onClick={() => setDeleteClicked(true)}
                                        disabled={deleteClicked}
                                    >
                                        Delete Scrape Entry
                                    </Button>
                                </div>
                                {deleteClicked && (
                                    <div className="alert alert-danger">
                                        <strong>Final Confirmation:</strong> This scrape entry will be permanently deleted. This action cannot be undone.
                                        <br /><br />
                                        <Button 
                                            variant="danger" 
                                            disabled={deleteLoading} 
                                            onClick={() => {
                                                scrapeEntryDeleteFn()
                                            }}
                                        > 
                                            {deleteLoading ? 'Deleting...' : 'Confirm Delete Scrape Entry'}
                                        </Button>
                                    </div>
                                )}
                            </Stack>

                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}